import * as React from 'react';
import _ from 'lodash';
import NoSearchResults from '../NoSearchResults/NoSearchResults';
import SearchResultsRow from './SearchResultsRow/SearchResultsRow';
import SearchTableHeader from './SearchTableHeader/SearchTableHeader';
import SearchBar from './SearchBar/SearchBar';
import * as Styled from './styled';
import PaginatedFetch from '../PaginatedFetch/PaginatedFetch';
import { getAdvancedSearchResults } from '../../../../logic/functions/advancedSearch.function';
import { SearchFilterValues } from '../../../../logic/domains/searchFilters.domain';
import { AEMContent } from '@mlc/web-ui-toolkit';

export interface AllResultsTabContentProps {
	customerNumber: string;
	customerToken: string;
	totalCount: number;
	searchFilters: SearchFilterValues;
	updateTotalResultsCount: Function;
}
const PAGE_LENGTH = 25;

const AllResultsTabContent: React.FunctionComponent<AllResultsTabContentProps> = (
	props: AllResultsTabContentProps
) => {
	const noResultsComponent = (
		<NoSearchResults
			url="content/dam/mlcsecure/adviser/images/no-search-results.png"
			alt="No results magnifying glass"
		/>
	);

	const disclaimer = (
		<AEMContent
			variant="disclaimer"
			path="/secure/_content/Adviser/search-results/disclaimer"
		/>
	);

	return (
		<div data-analytics-group="advanced-search-all-tab">
			<Styled.Card paddingBottom={8}>
				<SearchBar
					customerNumber={props.customerNumber}
					customerToken={props.customerToken}
					totalCount={props.totalCount}
					searchFilters={props.searchFilters}
				/>
				<PaginatedFetch
					tableHeader={<SearchTableHeader />}
					noSearchResults={noResultsComponent}
					filters={props.searchFilters}
					updateTotalResultsCount={props.updateTotalResultsCount}
					fetchNextPage={async (query: any) => {
						const { pageNumber, ...rest } = query;
						return await getAdvancedSearchResults(props.customerToken, {
							size: PAGE_LENGTH,
							page: pageNumber,
							...rest,
						});
					}}
					disclaimer={disclaimer}
				>
					{(data: Array<any>) => {
						return _.map(data, result => {
							return <SearchResultsRow key={result.id} data={result} />;
						});
					}}
				</PaginatedFetch>
			</Styled.Card>
		</div>
	);
};

export default AllResultsTabContent;
